@import 'src/global/theme-variables';

.rv-container {
  display: flex;
  padding: 16px;
  position: relative;
  border: 1px solid #eee;
  border-radius: 7px;
  flex-direction: column;
  justify-content: space-between;
  width: auto;
  height: 202px;

  * {
    font-family: Inter, Roboto, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Helvetica Neue',
      Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
  }
}

.rv-header-container {
  display: flex;
}

.rv-title {
  display: flex;
  color: $secondary;
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  padding: 0;
  text-align: left;
  flex-grow: 1;
  line-height: 1.235;
}
